import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import { NavLink,browserHistory } from "react-router-dom";
import Welcome from "./components/welcome/Welcome";
import Home from "./components/main/home";
import Signin from "./components/welcome/Signin";
import Phonelogin from "./components/welcome/Phonelogin";
import Signupfirebase from "./components/welcome/Signupfirebase";
import Helpmain from "./components/help/Helpmain";
import Loader from 'react-loader-spinner';
//import { messaging } from "./init-fcm";
import { license } from "./license/License";
import axios from 'axios';
// import Cookies from 'universal-cookie';
import NotFound from './components/NotFound/NotFound';
import Referrel from './components/welcome/Referrel';

let val = license();
class App extends Component {
    authenticate() {
        return new Promise(resolve => setTimeout(resolve, 1500))
    }
    constructor(props) {
        super(props);
        this.state = {
            email: ""
        }
        this.get_appdefault = this.get_appdefault.bind(this)

        /* io.on('connection', (client) => {
             // here you can start emitting events to the client 
       });
         const port = 8085;
           io.listen(port);
           console.log('listening on port ', port);*/
    }

    UNSAFE_componentWillMount = () => {
        window.scrollTo(0, 0);
        this.get_appdefault();

    }
    componentWillMount() {

    }
    async componentDidMount() {

        /*messaging.onMessage((payload) => console.log('Message received. ', payload));
            navigator.serviceWorker.addEventListener("message", (message) => console.log(message));
            
        messaging.requestPermission().then(async function() {
            const token = await messaging.getToken();
            console.log(token)
            cookies.set('mytoken', token);
        }).catch(function(err) {
            console.log("Unable to get permission to notify.", err);
        });*/
        // console.log(val); 
        var formdata = new FormData();
        formdata.set('hostname', val);
        axios({
            method: 'post',
            url: localStorage.getItem('api_url') + 'checklicense',
            data: formdata,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            if (res.data) {
                //window.location=window.location.protocol+'//'+window.location.hostname+'/Invalidlicense.js';
            }
        })

        this.authenticate().then(() => {
            const ele = document.getElementById('loader')
            if (ele) {
                ele.classList.add('available')
                setTimeout(() => {
                    ele.outerHTML = ''
                }, 500)
            }
        })
    }

    async get_appdefault() {
        await axios.get(localStorage.getItem('api_url') + `admindatas`)
            .then(res => {
                const stripe_public_key = res.data.result.stripe_public_key;
                localStorage.setItem("settings", JSON.stringify(res.data.result))
                localStorage.setItem('stripe_public_key', stripe_public_key);
            })
    }

    render() {
        var style = {
            zIndex: 10,
            backgroundColor: "white",
            height: "100vh",
            width: "100vw",
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            //width:"100%",
            overflowY: "hidden"
        };

        //(here 'howzureact' is subdirectory name, so able to run app on http://domain/howzureact)

        return (

            <Router basename={'/moulookweb/web'}>

                <div>
                    <div className="loder-icon">
                        <div style={style} id="loader">
                            <Loader type="Bars" color="#ca2a1e" height={30} width={50} />
                        </div>
                    </div>
                    <Switch>
                        <Route exact path="/" component={Welcome} />
                        <Route exact path="/referrel/:referrel" component={Referrel} />
                        <Route path="/login" component={Signin} />
                        <Route path="/phonelogin" component={Phonelogin} />
                        <Route path="/Signupfirebase" component={Signupfirebase} />
                        <Route path="/app" component={Home}></Route>
                        <Route exact path="/helpmain" component={Helpmain}></Route>
                        <Route component={NotFound} />
                    </Switch>
                </div>
            </Router>

        );
    }
}

export default App;
